export default "__VITE_ASSET__C3_nMgAI__"